import { render, staticRenderFns } from "./FormIdentity.vue?vue&type=template&id=7b23f1e4&"
import script from "./FormIdentity.vue?vue&type=script&lang=js&"
export * from "./FormIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports